// Catálogo de juegos: fuente única de nombre, descripción, color e icono.
// Añadir un juego nuevo aquí lo muestra en la portada, el menú y el ranking.
import type { ReactNode } from 'react';

export type GameId = 'minesweeper' | 'snake';

export interface GameInfo {
  id: GameId;
  name: string;
  tagline: string;      // una línea para la portada
  route: string;        // pantalla del juego
  needsAccount: boolean; // requiere sesión (invitado o registrado)
  glyph: ReactNode;     // dibujo del icono (rejilla 24, ver brand/game-icons)
}

// Iconos dibujados con el sistema de brand/game-icons (style-spec.json):
// rejilla 24, trazo 2,5 redondeado y una pieza maciza por icono (aquí la mina, con el brillo hueco).
// El trazo y el color los pone GameIcon (currentColor = blanco sobre el color del juego).
const MinesweeperGlyph = (
  <>
    <path d="M12 2.75v3.5M12 17.75v3.5M2.75 12h3.5M17.75 12h3.5M5.5 5.5l2 2M16.5 16.5l2 2M18.5 5.5l-2 2M7.5 16.5l-2 2"/>
    <path d="M12 5.25a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5zM9.75 8.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5z" fill="currentColor" fillRule="evenodd" stroke="none"/>
  </>
);

const SnakeGlyph = (
  <>
    <path d="M4.5 19.5h10a2.5 2.5 0 0 0 0-5h-5a2.5 2.5 0 0 1 0-5H14" strokeWidth="3.5"/>
    <path d="M16.5 5.75a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5zm.9 2.1a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2z" fill="currentColor" fillRule="evenodd" stroke="none"/>
  </>
);

export const GAMES: GameInfo[] = [
  { id: 'minesweeper', name: 'Buscaminas', tagline: 'Despeja el campo sin pisar una mina. Ranking por tiempo.', route: '/buscaminas', needsAccount: false, glyph: MinesweeperGlyph },
  { id: 'snake', name: 'Snake', tagline: 'Come, crece y no choques. Cada punto la hace más rápida.', route: '/snake', needsAccount: false, glyph: SnakeGlyph },
];

export const GAMES_BY_ID = Object.fromEntries(GAMES.map((g) => [g.id, g])) as Record<GameId, GameInfo>;
